import { FormField, FormSection } from "generated/graphql";
import { FC, useEffect } from "react";
import { useAppSelector } from "redux/hooks";
import { selectProfileBuilderFields } from "redux/slices/lensEditor";
import Fields from "./Fields";
import { useNavigate } from "react-router";

interface SectionsProps {
  formId: number;
  sections: FormSection[];
  handleFieldClick: (field: FormField) => void;
  handleDeleteField: (fieldId: number) => void;
  sectionId?: number;
}

const Sections: FC<SectionsProps> = ({ sections, handleFieldClick, handleDeleteField, sectionId }) => {
  const navigate = useNavigate();
  const allFields = useAppSelector(selectProfileBuilderFields);

  useEffect(() => {
    if ((sectionId === undefined && sections.length > 0) || !sections.find((s) => s.id === sectionId)) {
      const section = sections[0];

      if (section !== undefined) {
        navigate(`../${section.id}`);
      }
    }
  }, [sectionId]);

  return (
    <Fields
      fields={allFields.filter((f) => f.sectionId === sectionId)}
      handleFieldClick={handleFieldClick}
      handleDeleteField={handleDeleteField}
      sectionId={sectionId}
    />
  );
};

export default Sections;
